import "../styles/styles.scss"
import "../styles/global.css"
import "../styles/layout.css"
import "../styles/page.scss"
import "../styles/hero.scss"
import "../styles/terminal-backdrop.scss"
import * as React from "react"
import Footer from "./Footer"
import DeferredEffects from "./DeferredEffects"

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <div className="mainContainer">
        {children}
        <Footer />
      </div>
      <DeferredEffects />
    </>
  )
}

export default Layout
